'use es6';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import { CREATE_NEW_REPORT, EDIT_EXISTING_REPORT } from 'reporting-action-components/reportingActions/saveReport/saveNewReportTypes';
import { LOADING } from 'reporting-action-components/reportingActions/problems';
import { track as dashboardTracker, EVENTS } from 'dashboard-ui-components/tracking/DashboardUITracker';
import { getDataFirstFlowUrl, getReportLibraryUrl, getReportListUrl } from 'dashboard-components/lib/urlHelpers';
import { selectHasDataFirstFlowAccess, selectHasReportSetupAccess } from 'dashboard-lib/public/userInfo/gates';
import { selectHasCustomReportingAcccess } from 'dashboard-lib/public/userInfo/scopes';
import useAddReportsToAnyDashboardProblem from 'reporting-action-components/reportingActions/addReportToDashboard/useAddReportsToAnyDashboardProblem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LIBRARY_OPTION_KEY = 'from-library';
const LIST_OPTION_KEY = 'from-saved';
const AddReportActionDropdown = props => {
  const {
    buttonText,
    currentDashboardId,
    dashboard,
    sourceName
  } = props;
  const hasDataFirstFlowAccess = useSelector(selectHasDataFirstFlowAccess);
  const hasReportSetupAccess = useSelector(selectHasReportSetupAccess);
  const hasCustomReportingAccess = useSelector(selectHasCustomReportingAcccess);
  const {
    problem: addFromSavedProblem,
    disabledMessage: addFromSavedDisabledMessage
  } = useAddReportsToAnyDashboardProblem({
    reports: [],
    currentDashboard: dashboard,
    EDIT_EXISTING_REPORT
  });
  const {
    problem: addFromLibraryProblem,
    disabledMessage: addFromLibraryDisabledMessage
  } = useAddReportsToAnyDashboardProblem({
    reports: [],
    currentDashboard: dashboard,
    CREATE_NEW_REPORT
  });
  const AddReportOption = ({
    optionKey,
    labelKey,
    problem,
    Message,
    destination,
    dataTestId
  }) => /*#__PURE__*/_jsx(UITooltip, {
    title: Message && /*#__PURE__*/_jsx(Message, {}),
    placement: "left",
    disabled: !problem,
    children: /*#__PURE__*/_jsx(UIButton, {
      disabled: !!problem,
      onClick: () => {
        dashboardTracker(EVENTS.clickAddReport, {
          source: sourceName,
          option: optionKey
        });
        window.location = destination;
      },
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: labelKey
      })
    })
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    title: addFromSavedDisabledMessage,
    placement: "left",
    disabled: !addFromSavedProblem,
    children: /*#__PURE__*/_jsx(UIDropdown, {
      buttonText: buttonText,
      disabled: !!addFromSavedProblem,
      placement: "bottom left",
      buttonUse: "primary",
      buttonSize: "sm",
      "data-test-id": addFromSavedProblem !== LOADING && 'dashboard-action-add-report',
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(AddReportOption, {
          labelKey: "dashboardHeader.addReport.fromSavedUngatedDiscover",
          optionKey: LIST_OPTION_KEY,
          problem: addFromSavedProblem,
          Message: addFromSavedDisabledMessage,
          destination: getReportListUrl(currentDashboardId)
        }), /*#__PURE__*/_jsx(AddReportOption, {
          labelKey: "dashboardHeader.addReport.discover",
          optionKey: LIBRARY_OPTION_KEY,
          problem: addFromLibraryProblem,
          Message: addFromLibraryDisabledMessage,
          destination: hasDataFirstFlowAccess ? getDataFirstFlowUrl() : getReportLibraryUrl(currentDashboardId, hasReportSetupAccess, hasCustomReportingAccess),
          dataTestId: "discover-reports-action-dropdown"
        })]
      })
    })
  });
};
AddReportActionDropdown.propTypes = {
  buttonText: PropTypes.node.isRequired,
  currentDashboardId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  dashboard: PropTypes.object,
  sourceName: PropTypes.string.isRequired
};
export default AddReportActionDropdown;